import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const images = [
  "/images/gurudev-1.jpeg",
  "/images/img2.jpeg",
  "/images/img3.jpeg",
];

export default function PortraitSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  const nextSlide = () => {
    setCurrentIndex((prev) =>
      prev === images.length - 1 ? 0 : prev + 1
    );
  };

  // ✅ Auto Slide
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 3000); // 3 seconds

    return () => clearInterval(interval); // cleanup
  }, [currentIndex]); // re-run when index changes

  return (
    <div style={styles.slider}>
      
      {/* Left Arrow */}
      <button onClick={prevSlide} style={styles.leftArrow}>
        <ChevronLeft size={30} />
      </button>

      {/* Image */}
      <img
        src={images[currentIndex]}
        alt="slider"
        style={styles.image}
      />

      {/* Right Arrow */}
      <button onClick={nextSlide} style={styles.rightArrow}>
        <ChevronRight size={30} />
      </button>

    </div>
  );
}

const styles = {
  slider: {
    position: "relative",
    width: "500px",
    height: "650px",
    margin: "auto",
    overflow: "hidden",
    borderRadius: "10px",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  leftArrow: {
    position: "absolute",
    top: "50%",
    left: "10px",
    transform: "translateY(-50%)",
    background: "rgba(0,0,0,0.5)",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    padding: "5px",
    borderRadius: "50%",
  },
  rightArrow: {
    position: "absolute",
    top: "50%",
    right: "10px",
    transform: "translateY(-50%)",
    background: "rgba(0,0,0,0.5)",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    padding: "5px",
    borderRadius: "50%",
  },
};